// เข้ามาทาง deep link ของเมนูที่ถูกปิดไว้ → บอกให้ชัดว่าปิดอยู่ ไม่ใช่ปล่อยกรอบว่าง
import type { Brand } from "@contracts/api";
import { brandCfgLink, type FeatureOff } from "@features/navigation/model/side-menus";
import { EmbedHead } from "./embed-head";

export function FeatureOffView({ brand, off }: { brand: Brand; off: FeatureOff }) {
  return (
    <>
      <EmbedHead crumb={`${brand.name} / ${off.crumb}`} title={off.crumb.split(" / ").pop()!} />
      <div className="embed-frame">
        <div className="embed-empty">
          <h3>ปิดการแสดงไว้</h3>
          <p className="muted">
            แบรนด์นี้ปิดการดึง {off.label} มาแสดงไว้
            <br />
            เปิดได้ที่ <a href={brandCfgLink(brand)}>หน้าตั้งค่า → Channels &amp; Inbox</a>
          </p>
        </div>
      </div>
    </>
  );
}
